import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  category: FunctionCategory.MATH,
  params: [],
  name: 'NULL',
  description: 'Returns empty values.',
  shortDescription: 'Null',
} satisfies AnalysisFunction;
